import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "view-select-buttons",
  templateUrl: "./view-select-buttons.component.html",
  styleUrls: ["./view-select-buttons.component.scss"],
})
export class ViewSelectButtonsComponent implements OnInit {
  @Input()
  chartNames;
  @Input()
  selectedChart;
  @Input()
  disableBtns;
  @Input()
  domainId;
  @Input()
  metricId;
  @Output() changeSelectedChart = new EventEmitter();

  partialImagePath: string = "../../assets/images/";
  hoverChart;

  constructor() {}

  ngOnInit() {}

  selectChart(chart) {
    this.changeSelectedChart.emit({
      value: chart,
    });
  }

  highlightChart(chart) {
    this.hoverChart = chart;
  }

  unHighlightChart(chart) {
    if (this.hoverChart === chart) {
      this.hoverChart = null;
    }
  }

  getFullImagePath(img, chart) {
    if (
      this.selectedChart === chart ||
      (this.hoverChart && this.hoverChart === chart)
    ) {
      return this.partialImagePath + img + "_active.svg";
    } else {
      return this.partialImagePath + img + ".svg";
    }
  }

  getExpandImagePath() {
    if (this.hoverChart && this.hoverChart === "expand") {
      return this.partialImagePath + "expand_active.svg";
    } else {
      return this.partialImagePath + "expand.svg";
    }
  }
}
